import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, CardMedia } from "@mui/material";
import { getFromStorage } from "../helpers/storage";
import { STORAGE_KEYS } from "../constants/storageKeys";
import useTranslation from "../hooks/traslation";

interface CategoryViewModalProps {
  open: boolean;
  selectedId: string;
  onClose: () => void;
  setSelectedId: Dispatch<SetStateAction<string>>;
  setOpen: Dispatch<SetStateAction<boolean>>;
  data: {
    name: string;
    name_ar: string;
    image: string;
    description: string;
    description_ar: string;
    subCategory?: {
      name: string;
      name_ar: string;
    };
  } | null;
}

export default function CategoryViewModal({
  setOpen,
  open,
  selectedId,
  onClose,
  setSelectedId,
  data,
}: CategoryViewModalProps) {
  const getLang = getFromStorage(STORAGE_KEYS.language);
  const translate = useTranslation();

  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>{translate?.main?.categoryDetail}</h2>
            <div
              className="btn-close"
              onClick={() => {
                setSelectedId("");
                setOpen(false);
              }}
            >
              <CloseIcon />
            </div>
          </div>

          <form className="form" action="">
            {data?.image && (
              <div className="control_group">
                <label>{translate?.main?.categoryImg}</label>
                <CardMedia
                  component="img"
                  image={data.image}
                  alt="Category"
                  style={{
                    width: "80px",
                    height: "80px",
                    objectFit: "cover",
                    borderRadius: "50%",
                  }}
                />
              </div>
            )}
            <div className="control_group">
              <label>{translate?.main?.categoryName}</label>
              <TextField
                placeholder={translate?.user?.enterCategoryName}
                fullWidth
                value={getLang === "en" ? data?.name : data?.name_ar}
                hiddenLabel
                disabled={true}
              />
            </div>

            {data?.subCategory && (
              <div className="control_group">
                <label>Sub Category</label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span>{data?.subCategory?.name || ""}</span>
                </div>
              </div>
            )}

            {data?.description ? (
              <div className="control_group">
                <label>{translate?.globals?.description}</label>
                <TextField
                  placeholder={translate?.globals?.description}
                  fullWidth
                  value={getLang === "en" ? data?.description : data?.description_ar}
                  hiddenLabel
                  disabled={true}
                  multiline
                  maxRows={5}
                  minRows={5}
                />
              </div>
            ) : null}
          </form>
        </div>
      </div>
    </Modal>
  );
} 